var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveLogging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3840 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wave"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0 718.6h1920V1080H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0 718.6h1920V1080H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0 718.6h1920V1080H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3838.1 880.5s-207.3 4.8-461.3-23c-260.9-21.5-395.8-11.7-530.6-3.9-272.4 13.2-379.4 56.2-612 1.5-92.5-21.7-191.8-46.9-314.2-31.2-85.8 14-176.2 31.4-268.7 53.1-232.6 54.7-473.1 15.6-619.3-21.7C786 792.8 416.6 698 242.8 722.5 146.2 736.2 65.3 779.5 0 832.4V1080h3840V879.5l-1.9 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1920 718.6h1920V1080H1920z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1920 718.6h1920V1080H1920z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1920 718.6h1920V1080H1920z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveLogging);
export default __webpack_public_path__ + "static/media/waveLogging.5f8fb24b159473b48f3bedda1d1730e8.svg";
export { ForwardRef as ReactComponent };